import React, { useRef } from 'react';
import { Box, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useStyles } from './styles';
import EDIT_ICON from '../../../../assets/svg/edit-icon.svg';
import DELETE_ICON from '../../../../assets/svg/delete-icon.svg';
import { useTranslation } from 'react-i18next';
import { LANG_TEXT } from '../../../../constants/language';

interface ImageUploaderProps {
  imageUrl: string;
  onImageChange: (imageUrl: string) => void;
  onRemoveImage: () => void;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({ imageUrl, onImageChange, onRemoveImage }) => {
  const classes = useStyles();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const fileInputEditRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      const reader = new FileReader();
      reader.onload = () => {
        const imageUrl = reader.result as string;
        onImageChange(imageUrl);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box className={classes.BoxGroupImage}>
      {imageUrl ? (
        <Box className={classes.BoxImage}>
          <img src={imageUrl} style={{ width: '100%', height: '100%' }} alt="Uploaded" />
        </Box>
      ) : (
        <Box
          className={classes.BoxUploadImage}
          onClick={() => {
            if (fileInputRef.current) {
              fileInputRef.current.click();
            }
          }}
        >
          <input ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={handleFileChange} accept="image/*" />
          <AddIcon />
        </Box>
      )}
      {imageUrl && (
        <Box className={classes.Icons}>
          <Box
            className={classes.EditButton}
            onClick={() => {
              if (fileInputEditRef.current) {
                fileInputEditRef.current.click();
              }
            }}
          >
            <input ref={fileInputEditRef} type="file" style={{ display: 'none' }} onChange={handleFileChange} accept="image/*" />
            <img src={EDIT_ICON} height={24} width={24} alt="EDIT_ICON" />
            <Typography fontSize={16} lineHeight={'24px'} color={'var(--Primary-600, #30893C)'}>
              {t(LANG_TEXT.EDIT)}
            </Typography>
          </Box>
          <Box className={classes.Divider}></Box>
          <Box className={classes.EditButton} onClick={onRemoveImage}>
            <img src={DELETE_ICON} height={24} width={24} alt="DELETE_ICON" />
            <Typography fontSize={16} lineHeight={'24px'} color={'var(--Error-600, #D92D20)'}>
              {t(LANG_TEXT.DELETE)}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ImageUploader;
